import moment from 'moment'

export const columns = () => [
  {
    name: 'Id',
    selector: (row) => row.id,
    width: '100px'
  },
  {
    name: 'Tipo de DTE',
    selector: (row) => row.tipoDte,
    width: '140px'
  },
  {
    name: 'Fecha Emisión',
    selector: (row) => moment(row.fechaEmision).format('YYYY-MM-DD'),
    width: '140px'
  },
  {
    name: 'Número de Control',
    selector: (row) => row.numeroControl,
    width: '320px'
  },
  {
    name: 'Código de Generación',
    selector: (row) => row.codigoGeneracion,
    width: '380px'
  },
  {
    name: 'Sello',
    selector: (row) => row.selloRecibido,
    width: '420px'
  },
  {
    name: 'Nombre Emisor',
    selector: (row) => row.emisorNombre,
    width: '500px'
  },
  {
    name: 'Documento del Emisor',
    selector: (row) => row.emisorTipoDocumento,
    width: '200px'
  },
  {
    name: 'Número de Documento del Emisor',
    selector: (row) => row.emisorNumeroDocumento,
    width: '300px'
  },
  {
    name: 'NRC',
    selector: (row) => row.emisorNrc,
    width: '130px'
  },
  {
    name: 'Correo Emisor',
    selector: (row) => row.emisorCorreo,
    width: '380px'
  },
  {
    name: 'IVA',
    selector: (row) => row.totalIva,
    width: '120px'
  },
  {
    name: 'Venta Grabada',
    selector: (row) => row.ventaGravada,
    width: '150px'
  },
  {
    name: 'Venta No Grabada',
    selector: (row) => row.ventaNoGravada,
    width: '180px'
  },
  {
    name: 'TOTAL',
    selector: (row) => row.montoTotal,
    width: '180px'
  },
]
